/**
 * <ComputedField> — 13-ui-screens.md §3.7, 14-theme.md §6.1 rule 6.
 *
 * A read-only computed figure sits on a DASHED border with a subtle fill;
 * an editable figure sits on a SOLID border with a white fill. That contrast
 * is how a clerk tells at a glance what they may type into.
 *
 * antd's `<Input disabled>` is a solid grey box and reads as "broken input",
 * not "derived value", so it is not used here.
 */
import type { CSSProperties, ReactNode } from 'react';

export interface ComputedFieldProps {
  children: ReactNode;
  align?: CSSProperties['justifyContent'];
  minWidth?: number | string;
  title?: string;
}

export function ComputedField({
  children,
  align = 'flex-end',
  minWidth,
  title,
}: ComputedFieldProps) {
  return (
    <div className="cm-computed" style={{ justifyContent: align, minWidth }} title={title}>
      {children}
    </div>
  );
}
